import { getEnv } from "../env";
import { isLoadedInIframe } from "./isLoadedInIframe";

export function getUrlToFetch(url) {
	const apiDomain = getEnv('REACT_APP_API_DOMAIN');

	try {
		if(new URL (window.location.origin)?.hostname?.startsWith("localhost") && apiDomain && !url.startsWith(apiDomain)) {
			return [apiDomain,url].join('');
		}else if(isLoadedInIframe()) {
			return [apiDomain,url].join('');
		}
		else{
			return url;
		}
	}catch(err) {
		return url;
	}
}
